import { ArrowRight } from "lucide-react";
import Link from "next/link";

export default function TeamBanner() {
  return (
    <section
      className="flex w-full items-center justify-start h-[550px] md:h-[600px] px-6 md:pl-25 py-10 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: "url('/images/bbgg.jpg')",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="flex flex-col w-full md:w-1/2 p-6 md:p-10 gap-6 md:gap-10 bg-gray-200/30 backdrop-blur-2xl text-white">
        <h2 className="text-[28px] md:text-[40px] font-lora font-semibold leading-[36px] md:leading-[48px]">
          We offer client-focused legal counsel for both businesses and individuals.
        </h2>

        <Link
          href="/contact-us"
          className="flex items-center justify-center w-full md:w-auto px-4 py-4 gap-2 text-black bg-secondary font-semibold"
        >
          Schedule free consultation
          <ArrowRight />
        </Link>
      </div>
    </section>
  );
}
